import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import IlFuturoDellaTuaPmi from "./sections/IlFuturoDellaTuaPmi";
import MetricheDiImpatto from "./sections/MetricheDiImpatto";
import TechnicalSolutionsEcosystem from "./sections/TechnicalSolutionsEcosystem";
import IlDirettoreStrategico from "./sections/IlDirettoreStrategico";
import TheyBelievedInUs from "./sections/TheyBelievedInUs";
import InitializeConnection from "./sections/InitializeConnection";
import FondamentaFinali from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <IlFuturoDellaTuaPmi />
      <MetricheDiImpatto />
      <TechnicalSolutionsEcosystem />
      <IlDirettoreStrategico />
      <TheyBelievedInUs />
      <InitializeConnection />
      <FondamentaFinali />
    </div>;
}